/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { AvgProxyControllerService } from './services/AvgProxyControllerService';
import { BridgeProxyControllerService } from './services/BridgeProxyControllerService';
import { DataSourceControllerService } from './services/DataSourceControllerService';
import { MapLayerControllerService } from './services/MapLayerControllerService';
import { NotificationControllerService } from './services/NotificationControllerService';
import { SearchOptionsControllerService } from './services/SearchOptionsControllerService';
import { TravelTimeProxyControllerService } from './services/TravelTimeProxyControllerService';
import { WazeIncidentsProxyControllerService } from './services/WazeIncidentsProxyControllerService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class ViewerApiClientV2 {
    public readonly avgProxyController: AvgProxyControllerService;
    public readonly bridgeProxyController: BridgeProxyControllerService;
    public readonly dataSourceController: DataSourceControllerService;
    public readonly mapLayerController: MapLayerControllerService;
    public readonly notificationController: NotificationControllerService;
    public readonly searchOptionsController: SearchOptionsControllerService;
    public readonly travelTimeProxyController: TravelTimeProxyControllerService;
    public readonly wazeIncidentsProxyController: WazeIncidentsProxyControllerService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '/api/v2',
            VERSION: config?.VERSION ?? '0.0.1',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.avgProxyController = new AvgProxyControllerService(this.request);
        this.bridgeProxyController = new BridgeProxyControllerService(this.request);
        this.dataSourceController = new DataSourceControllerService(this.request);
        this.mapLayerController = new MapLayerControllerService(this.request);
        this.notificationController = new NotificationControllerService(this.request);
        this.searchOptionsController = new SearchOptionsControllerService(this.request);
        this.travelTimeProxyController = new TravelTimeProxyControllerService(this.request);
        this.wazeIncidentsProxyController = new WazeIncidentsProxyControllerService(this.request);
    }
}

